import { useTranslate } from 'core/hooks/useTranslate';
import TextHtml from 'core/modules/atoms/TextHtml';
import { AssetImage, Dialog } from 'ui';
import React, { useState } from 'react';

const LandingEdelvivesPlus = () => {
  const { t } = useTranslate();

  const [showKnowMore, setShowKnowMore] = useState(false);

  return (
    <div className="landing-edelvives-plus">
      <div className="landing-edelvives__wrapper">
        <div className="landing-edelvives-plus__logo">
          <AssetImage id="logoWhite" alt={t('alt:Edelvives logo')} />
        </div>
        <div className="landing-edelvives-plus__text">{t('auth:Edelvives virtual learning environment')}</div>
        <div className="landing-edelvives__know-more" onClick={() => setShowKnowMore(true)}>
          <span>{t('auth:Know more')}</span>
        </div>
      </div>
      <Dialog isOpen={showKnowMore} size="l" className={'dialog-show-know-more'} title={t('auth:Know more')} onClose={() => setShowKnowMore(false)}>
        <div className="dialog-show-know-more__container">
          <TextHtml text={t('auth:Know more text')} />
        </div>
      </Dialog>
    </div>
  );
};

export default LandingEdelvivesPlus;
